const clientToCompile = "wepos"
const clients = {
    "wepos": "https://backend.wesyncro.click",
    "woopy": "https://woopy.nupyapp.com"
}
  
export const url_base = clients[clientToCompile] || ""